import { computed, reactive, readonly } from 'vue'
import { api, configureClient } from '../api/client'
import type { AdminMe, User } from '../api/types'

// 会话 8h；关标签即清，不用 localStorage。
const TOKEN_KEY = 'reellax.admin.token'

let token: string | null = sessionStorage.getItem(TOKEN_KEY)
const expiryListeners = new Set<() => void>()

function setToken(next: string | null) {
  token = next
  if (next) sessionStorage.setItem(TOKEN_KEY, next)
  else sessionStorage.removeItem(TOKEN_KEY)
}

configureClient({
  getToken: () => token,
  onExpired: () => {
    setToken(null)
    expiryListeners.forEach((fn) => fn())
  },
})

type Status = 'checking' | 'authenticated' | 'anonymous'

const state = reactive({
  status: (token ? 'checking' : 'anonymous') as Status,
  me: null as AdminMe | null,
})

function applyMe(next: AdminMe) {
  state.me = next
  state.status = 'authenticated'
}

function clearSession() {
  setToken(null)
  state.me = null
  state.status = 'anonymous'
}

if (token) {
  api
    .me()
    .then(applyMe)
    .catch(() => {
      clearSession()
    })
}

expiryListeners.add(() => {
  state.me = null
  state.status = 'anonymous'
})

async function login(email: string, password: string) {
  const result = await api.login(email, password)
  setToken(result.access_token)
  applyMe(await api.me())
}

async function logout() {
  try {
    await api.logout()
  } catch {
    // 仍清本地，避免假登录态
  }
  clearSession()
}

async function refreshMe() {
  applyMe(await api.me())
}

export function useSession() {
  return {
    status: computed(() => state.status),
    user: computed(() => (state.me?.user ?? null) as User | null),
    xtreamConfigured: computed(() => state.me?.xtream_configured ?? false),
    login,
    logout,
    refreshMe,
    _state: readonly(state),
  }
}
